import cx from 'classnames';
import React from 'react';

import Close from '../Icons/Close';

import s from './basic-alert.module.css';
import { getAlertIcon } from './getAlertIcon';
import type { CommonAlertProps } from './types';

export interface BasicAlertProps extends CommonAlertProps {
    closable: boolean;
    title?: string;
    onClose?: () => void;
}

export const BasicAlert = ({
    children,
    type,
    className,
    title,
    closable,
    onClose,
    ...props
}: BasicAlertProps) => {
    return (
        <div className={cx(s.container, className, s[type])} {...props}>
            <div>{getAlertIcon(type)}</div>
            <div>
                {title && (
                    <h3 className={cx(s['margin-right-24'], s['line-height-24'])}>{title}</h3>
                )}
                {children && <div>{children}</div>}
            </div>
            {closable && (
                <button type="button" className={s.close} onClick={onClose}>
                    <Close />
                </button>
            )}
        </div>
    );
};
